



































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Field, Popup, Area,CellGroup,
  Radio,Dialog,
  Cell,Form,
  RadioGroup,
  Toast
  } from "vant";
import CustomUploader from "./components/CustomUploader.vue";
import CustomSelect from "./components/CustomSelect.vue";
import { jumpLink,goBack,closeWebView } from "@/utils/hybirdMethods";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import customField from "@/components/customField/index.vue";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'AddressProof',
  components: {
    customField,
    passwordErrorPrompt,
      [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [Form.name]: Form,
      [RadioGroup.name]: RadioGroup,
      [Dialog.Component.name]: Dialog.Component,
    customUploader: CustomUploader,
    CustomSelect:CustomSelect
  }
})
export default class AddressProof extends Vue {
  @createAccountModule.Getter("address_proof_info") address_proof_info: any;
  @createAccountModule.Mutation("SAVE_W8BEN_INFO") saveW8benInfo: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  addressProofImgObj = {};
  addressCode = "";
  form = {
      address_img: "",
      province_name: "",
      province_code: "",
      city_name: "",
      city_code: "",
      country_name: "",
      country_code: "",
      detail_address: "",

  };
  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ""
  };
  userInfo = {
      email:'',
      job_type: "1",

      company: "",
      vocation_attribute: "",
      vocation: "",
      job_age: 0,
      company_address: "",
      company_phone: "",

      job_type_other_describe:""
  };

  areaList = {};
  enAreaList = {
    province_list: {},
    city_list: {},
    county_list: {}
  };
  showAddressPicker = false;
  isLoadingAddress = true;

  // 就业情况
  employmentColumns: any = [];
  employmentText = "";
  showEmploymentPicker = false;
  jobAgeText = "";
  showJobAgePicker = false;
  jobAgeColumns: any = [];
  // employmentForm = {
  //     company: "",
  //     vocation_attribute: "",
  //     vocation: "",
  //     job_age: "",
  //     company_address: "",
  //     company_phone: ""
  // };
  // otherForm = {
  //     job_type_other_describe: ""
  // };
  //资产
  financial: any = [];
  //提交
  isSubmitBtn = false;
  checkPassword: string = ""; // 校验登录密码
  checkPasswordShow: boolean = false; // 显示弹出框
  isUnderReview = false //是否正在审核
  reviewStatus:any = '';  //审核状态

  get isSubmitDisabled() {
    return !(
      this.addressText &&
      this.form.address_img &&
      this.form.detail_address
    );
  }

  get addressText() {
    if (this.form.province_name) {
      return (
        this.form.province_name + this.form.city_name + this.form.country_name
      );
    } else {
      return "";
    }
  }

  get isEmployee() {
      return this.userInfo.job_type == "1" || this.userInfo.job_type == "2";
  }
  get isOther() {
      return this.userInfo.job_type == "5";
  }

  @Watch("addressProofImgObj", { deep: true })
  watchAddressProofImgObj(value) {
      
    this.form.address_img = value.content;
  }

  @Watch("address_proof_info", { deep: true, immediate: true })
  watchAddressProofInfo(val) {
    const { modify } = this.$route.query;
    if (!modify) return;
    const { address_img, address } = val;
    this.form = {
      ...this.form,
      ...address
    };
    this.addressProofImgObj = address_img;
  }

  @Watch("userInfo.job_type")
  watchFormEmployment(val) {
      const column = this.employmentColumns.find((item) => {
      return item.value == val;
      });
      
      this.employmentText = (column && column.text) || "";
  }

  @Watch("userInfo.job_age")
  watchFormJobAge(val) {
      const column = this.jobAgeColumns.find((item) => {
      return item.value == val;
      });
      
      this.jobAgeText = (column && column.text) || "";
  }

  created() {
      this.employmentColumns = this.$t(
      "open_account.personal_info_supply.employment_field.columns"
      );
      this.jobAgeColumns = this.$t(
      "open_account.personal_info_supply.employment_duration_field.columns"
      );

      this.isSubmitBtn = this.$route.query.isEdit == 'true'?true:false
      // this.financial = this.$t("open_account.survey.page_three.financial_list");
      this.initGetSupplementInfo()
  }

  handEmailBind() {
      if(!this.isSubmitBtn){
          return
      }
      this.$router.push({
          path: "/email-bind"
      });
  }

  handleConfirmEmployment(item) {
      
      this.userInfo.job_type = item.value;
      this.showEmploymentPicker = false;
  }

  handleConfirmJobAge(item) {
      
      this.userInfo.job_age = item.value;
      this.showJobAgePicker = false;
  }
  handleChangeParentValue() {
      const financial = this.financial.filter(item => {
      return item.type == "multiSelect";
      });
      
      financial[0].options.forEach(option => {
      const children = (option as any).children;
      children && (children.value = "");
      });
  }
  toggleCheckboxInput(item, option) {
      if (option.inputValue !== undefined) {
          const checked = item.value.includes(option.value);
          option.isChecked = checked;
          if (!checked) {
              option.inputValue = "";
          }
      }
  }
  beforeClose(action, done) {
      done(false);
  }

  confirm() {
      if (this.checkPassword === "") {
      Toast(this.$t("fail_reason.checkPasswordTips"));
      } else {
      (this as any).$apis
        .checkPasswordFail({
          password: this.checkPassword
          })
        .then((res: any) => {
          this.checkPasswordShow = false;
          if (res.code) {
            if (res.code === 100174 || res.code === 100173) {
              (this as any).pwdErrPromptOption.errCode = res.code;
              (this as any).pwdErrPromptOption.errHtml = res.data.err_msg.h5;
              (this as any).pwdErrPromptOption.show = true;
              (this as any).$refs["password-error-prompt-el"].show = true;
            }
            return;
          }
          (this as any).isChangeInfo = true;
          this.handleSaveSupplement()
          this.handleConfirmationData();
        });
      }
  }
  asyncValidatorEmail(val) {
    return new Promise((resolve) => {
      (this as any).$apis
      .checkEmailFail({email:val})
      .then((res) => {
          if(res.code === 0){
              resolve(true)
          }else{
              resolve(false)
          }

      })
      .catch(e => {
        
      });
    });
  }
  onSubmit(values) {
    
  }
  initGetSupplementInfo(){
      (this as any).$apis
      .getSupplementInfo()
      .then(res => {
        //extra_update_status: 0-待校验,1-不通过,2-通过,99-二次开户初始
        const { financialSituation, derivative,open_user_info,address,address_img,extra_update_status } = res;
        this.userInfo = open_user_info;
        this.financial = financialSituation.length?financialSituation:this.$t("open_account.survey.page_three.financial_list");
        Object.assign(this.form,address)
        this.addressProofImgObj = address_img
        this.isUnderReview = extra_update_status === 0 ? true:false
        if(extra_update_status === 0 || extra_update_status === 1){
          this.isSubmitBtn = true
        }
        this.reviewStatus = extra_update_status

        
        
        
      })
      .catch(e => {
        this.financial = this.$t("open_account.survey.page_three.financial_list");
        
      });
  }

  handleOpenAddressPicker() {
    if (Object.keys(this.areaList).length !== 0) {
      return;
    }
    //获得省市区json
    (this as any).$apis
      .getAddressLists()
      .then(res => {
        const { en, zh } = res;
        this.areaList = zh;
        this.enAreaList = en;
        this.isLoadingAddress = false;
      })
      .catch(e => {
        
      });
  }

  handleSetAddress(arr) {
    this.form.province_name = arr[0] ? arr[0].name : "";
    this.form.province_code = arr[0] ? arr[0].code : "";
    this.form.city_name = arr[1] ? arr[1].name : "";
    this.form.city_code = arr[1] ? arr[1].code : "";
    this.form.country_name = arr[2] ? arr[2].name : "";
    this.form.country_code = arr[2] ? arr[2].code : "";
    this.showAddressPicker = false;
  }

  translateAddressData(address) {
    const { province_code, city_code, country_code } = address;
    const { province_list, city_list, county_list } = this.enAreaList;
    const province_name = province_list[province_code];
    const city_name = city_list[city_code];
    const country_name = county_list[country_code];
    return {
      province_name,
      province_code,
      city_name,
      city_code,
      country_name,
      country_code
    };
  }

  //确认资料-跳转提示
  handleConfirmationData(){
    (this as any).$apis.getAccountSituation().then(res => {
      // hb_account_status  证券  hk_account_status 环球
      
      if(this.reviewStatus === 1 && this.isSubmitBtn){
        Dialog.alert({
          message: '申请信息已提交，系统将尽快处理，请耐心等待。',
        }).then(() => {
          closeWebView()
        });
        return
      }
      this.$router.push({
        path: "/cognition-of-derivatives",
        query: {
          isChangeInfo: (this as any).isChangeInfo ? 1 : 0, // 是否修改了資料 涉及到后续 客户确认的 同意内容显示
          ...(this as any).$route.query
        }
      });
    });
  }

  //提交按钮
  handleSubmit(){
    // if(this.isUnderReview){
    //   Dialog.alert({
    //     message: '资料审核中，不可重复提交',
    //     className: "setClassMk"
    //   }).then(() => {
    //     // on close
    //   });
    //   return
    // }
    this.checkPasswordShow = true
  }
  //修改资料
  handleSaveSupplement() {
      const params = {
          derivative:{ "t0": {"value": 1,"children": [] }},
          financialSituation: this.financial,
          open_user_info: this.userInfo,
          address: this.form,
          address_img:this.form.address_img
      };

      (this as any).$apis
      .saveSupplement(params)
      .then(() => {
      })
      .catch(e => {
        
      });
  }
  passwordErrorPromptConfirm(errCode) {
    (this as any).pwdErrPromptOption.show = false;
    if (errCode === 100173) {
      (this as any).checkPasswordShow = true;
      (this as any).$refs["custom-field-password"].setInputFocus();
      setTimeout(() => {
        (this as any).$refs["custom-field-password"].setInputFocus();
      }, 500);
    }
  }
}
